<div id="container" class="row">
  <div class="col-lg-3 col-md-3 hidden-md-down" *ngIf="showSidebar">
    <a class="close-button" href="javascript:;" (click)="hideSidebar()" *ngIf="allowHideSidebar && showSidebar">
      <i class="fas fa-times"></i>
    </a>
    <aside id="sidebar-left">
        <tyt-shows-sidebar [title]="'NETWORK SHOWS'">
        </tyt-shows-sidebar>

        <hr/>

        <tyt-mobile-ad-block [title]="'Get TYT on the go!'"></tyt-mobile-ad-block>


        <ng-content select=".full-layout-sidebar"></ng-content>
    </aside>

    <tyt-newsletter-module class="sidebar"></tyt-newsletter-module>
  </div>
  <div class="col-md-12"
    [class.col-lg-9]="showSidebar"
    [class.col-lg-12]="!showSidebar">
    <ng-content></ng-content>
  </div>
</div>
